import BaseAPI from "../api";

const path: string = "period_examination";

export class PeriodExaminationApi extends BaseAPI {
  static createPeriodExamination(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getPeriodExaminationById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updatePeriodExamination(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deletePeriodExamination(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static deleteAdmissionStudent(id_period_examination: number, id_admission_student: number): Promise<any> {
    return this.api.delete(`${path}/${id_period_examination}/admission_student/${id_admission_student}`);
  }

  static autoScore(id: any): Promise<any> {
    return this.api.patch(`${path}/${id}/auto_score`);
  }

  static confirmScore(id: any): Promise<any> {
    return this.api.patch(`${path}/${id}/confirm_score`);
  }

  static getPeriodExaminationStudent(id_period_examination: any, id_period_examination_student: any): Promise<any> {
    return this.api.get(`${path}/${id_period_examination}/period_examination_student/${id_period_examination_student}`);
  }

  static updateStudentScore(id_period_examination: any, id_period_examination_student: any, body: any): Promise<any> {
    return this.api.patch(`${path}/${id_period_examination}/period_examination_student/${id_period_examination_student}/score`, body);
  }

  static getPeriodExaminationList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}